const getRowConfig = ({ securities, hideEnterpriseValueRow, isDisabled }) => [
  {
    largeHeader: true,
    skipParse: true,
  },
  ...securities.map(security => ({
    ignoreRowCopy: true,
    readOnly: isDisabled,
    ...security,
  })),
  {
    className: 'border-top',
    skipParse: true,
  },
  {
    skipParse: true,
    className: hideEnterpriseValueRow ? 'hidden' : '',
  },
];

export default getRowConfig;
